export const endPoints = {
  DEFAULT_CREATE: '/v1/lead/default-create',
  POST_DEFAULT_CREATE_LEAD: '/v1/client/default-create-lead',
  GET_REQUIRED_FIELDS: '/v1/lead/required-fields',
  GET_LEAD_CLIENT: '/v1/company-config/force-lead-client'
};
